{
  "seo": {
    "title": "Privacy Policy",
    "description": "Read CuriPop's privacy policy."
  },
  "title": "Privacy Policy",
  "updated": "Last updated: {date}",
  "sections": {
    "overview": {
      "title": "1. Privacy Overview",
      "body1": "This Privacy Policy explains what personal information we collect, how we use it, when we share it, and what choices are available to parents, guardians, and other users.",
      "body2": "CuriPop is built for children and families, and our data practices are designed to prioritize child privacy and safety."
    },
    "data": {
      "title": "2. Data We Collect",
      "lead": "We may collect the following categories of data:",
      "items": [
        "Account identifiers, such as parent email and authentication provider account ID.",
        "Child profile settings entered by a parent or guardian, such as nickname, grade, avatar preference, and reading-level preferences.",
        "Learning interaction data, including viewed questions, saved items, and feature usage signals.",
        "Technical and diagnostic data, such as browser type, app version, device metadata, timestamps, and error logs."
      ]
    },
    "usage": {
      "title": "3. Why We Use Data",
      "lead": "We process personal information to:",
      "items": [
        "Deliver core product functionality and account access.",
        "Tailor educational content and learner experiences.",
        "Monitor reliability, detect abuse, and secure the platform.",
        "Respond to support requests and service communications."
      ]
    },
    "children": {
      "title": "4. Children's Data",
      "body1": "Child accounts are expected to be created and supervised by a parent, guardian, or authorized educational administrator.",
      "body2": "We limit child data collection to what is reasonably necessary for educational operation. We do not knowingly sell child personal data or provide behaviorally targeted advertising to children."
    },
    "sharing": {
      "title": "5. When We Share Data",
      "lead": "We share data only in limited situations, such as:",
      "items": [
        "Service providers performing hosting, authentication, analytics, payments, and customer support on our behalf.",
        "Legal compliance, such as lawful requests, court orders, or protection of rights and safety.",
        "Corporate transactions such as merger, financing, acquisition, or asset transfer, subject to confidentiality and legal protections."
      ]
    },
    "cookies": {
      "title": "6. Cookies and Local Storage",
      "body1": "We use cookies and similar technologies to keep users signed in, remember preferences, protect sessions, and understand feature usage.",
      "body2": "Where required, users can control non-essential cookies through cookie preference settings."
    },
    "retention": {
      "title": "7. Data Retention",
      "body1": "We retain data for as long as needed to provide services, satisfy legal obligations, resolve disputes, enforce agreements, and maintain security records."
    },
    "security": {
      "title": "8. Security Practices",
      "body1": "We apply technical and organizational safeguards intended to protect personal information, including access controls and monitoring.",
      "body2": "No online service is completely risk-free, but we continuously improve our security program."
    },
    "rights": {
      "title": "9. Your Choices and Rights",
      "body1": "Depending on your location, you may have rights to access, correct, delete, or receive a copy of personal data.",
      "body2": "Parents and guardians may request management or deletion of child profile data by contacting us at hello@curipop.com."
    },
    "transfers": {
      "title": "10. International Data Transfers",
      "body1": "CuriPop may process data in countries other than your own. When this occurs, we use appropriate safeguards consistent with applicable law."
    },
    "updates": {
      "title": "11. Policy Updates",
      "body1": "We may update this Privacy Policy periodically. Material changes will be reflected by updating the \"Last updated\" date and, where required, additional notice."
    },
    "contact": {
      "title": "12. Contact Us",
      "body": "For privacy questions or data requests, contact"
    }
  }
}
